import { render } from "./OfficeMap.vue?vue&type=template&id=a8001fd4&scoped=true"
import script from "./OfficeMap.vue?vue&type=script&lang=js"
export * from "./OfficeMap.vue?vue&type=script&lang=js"

import "./OfficeMap.vue?vue&type=style&index=0&id=a8001fd4&scoped=true&lang=css"

import exportComponent from "/Users/elenejikia/Desktop/Parsons/Studio2/major-studio-2-sp24-1/06-vue-scrollytelling/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8001fd4"]])

export default __exports__